import { api } from "../../../configs/api";
import SharedPropsService from "../../../SharedPropsService";
import { defaultHeaders } from "../../../configs/config";
import AsyncStorage from "@react-native-async-storage/async-storage";
export const fetchBankRepo = async () => {
    const requestOptions = {
        method: "GET",
        headers: await defaultHeaders(),
    };
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : (await SharedPropsService.getUser())
        .linkedApplications[0].applicationId;
    return await fetch(`${api.bav}${applicationId}`, requestOptions)
        .then((response) => response.json())
        .catch((error) => console.log("error", error));
};
export const fetchPledgeLimitRepo = async () => {
    const user = await SharedPropsService.getUser();
    const requestOptions = {
        method: "GET",
        headers: await defaultHeaders(),
    };
    let applicationId = "";
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    return await fetch(`${api.pledgeLimit}${applicationId}`, requestOptions)
        .then((response) => response.json())
        .catch((error) => console.log("error", error));
};
export const PledgeCreateRepo = async (assetRepository, availableCASItem) => {
    const raw = JSON.stringify({
        applicationId: (await SharedPropsService.getUser()).linkedApplications[0]
            .applicationId,
        assetRepository,
        portfolioItemList: availableCASItem,
    });
    const requestOptions = {
        method: "POST",
        headers: await defaultHeaders(),
        body: raw,
    };
    return fetch(api.pledgeCreate, requestOptions)
        .then((response) => response.json())
        .catch((error) => {
        console.log("error", error);
        return error;
    });
};
